export default __webpack_public_path__ + "static/media/MaroonPeople.3f1daa11.pdf";